import { atom } from 'recoil'
import { User } from '@/core/models/user'

export const userState = atom<User | undefined>({
  key: 'user',
  default: undefined,
})
